module.exports = __webpack_public_path__ + "img/qbert_questions_p14.2c1d4761.jpg";